// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonWithInfo-module__container___3tnc-","info":"ButtonWithInfo-module__info___2XUuk","button":"ButtonWithInfo-module__button___2pGBq"};